// Validazione automatica del Codice Fiscale italiano e coerenza con nome/nascita.
// Nota: la verifica del comune di nascita (4 caratteri catastali) non è inclusa
// perché richiederebbe la tabella completa dei codici Belfiore.

const MONTHS = "ABCDEHLMPRST"; // indice 0..11 -> lettera mese

const ODD = {
  "0": 1, "1": 0, "2": 5, "3": 7, "4": 9, "5": 13, "6": 15, "7": 17, "8": 19, "9": 21,
  A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21, K: 2, L: 4, M: 18,
  N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};
const EVEN = {
  "0": 0, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9,
  A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9, K: 10, L: 11, M: 12,
  N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19, U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25,
};
const REMAINDER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

import { belfioreCode } from "./belfiore";

function checkChar(cf15) {
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    sum += i % 2 === 0 ? ODD[cf15[i]] : EVEN[cf15[i]];
  }
  return REMAINDER[sum % 26];
}

const normalize = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

const consonants = (s) => normalize(s).replace(/[^A-Z]/g, "").replace(/[AEIOU]/g, "");
const vowels = (s) => normalize(s).replace(/[^A-Z]/g, "").replace(/[^AEIOU]/g, "");

function surnameCode(sur) {
  return (consonants(sur) + vowels(sur) + "XXX").slice(0, 3);
}
function nameCode(name) {
  const c = consonants(name);
  const code = c.length >= 4 ? c[0] + c[2] + c[3] : c + vowels(name) + "XXX";
  return code.slice(0, 3);
}

function parseBirth(v) {
  if (!v) return null;
  const s = String(v).trim();
  let m;
  if ((m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/))) return { y: +m[1], m: +m[2], d: +m[3] };
  if ((m = s.match(/^(\d{1,2})[/.\- ](\d{1,2})[/.\- ](\d{4})/))) return { y: +m[3], m: +m[2], d: +m[1] };
  return null;
}

// Ritorna null (nessun messaggio) oppure { level: 'ok'|'warn'|'error', message }
export function validateCodiceFiscale(cf, nominativo, natoIl, natoA) {
  if (!cf || !cf.trim()) return null;
  const s = cf.trim().toUpperCase().replace(/\s/g, "");
  if (!/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(s)) {
    return { level: "error", message: "Formato non valido: il Codice Fiscale deve avere 16 caratteri." };
  }
  if (checkChar(s.slice(0, 15)) !== s[15]) {
    return { level: "error", message: "Codice Fiscale non valido: carattere di controllo errato." };
  }

  const issues = [];

  const bd = parseBirth(natoIl);
  if (bd) {
    let dd = parseInt(s.slice(9, 11), 10);
    if (dd > 40) dd -= 40;
    const okY = s.slice(6, 8) === String(bd.y % 100).padStart(2, "0");
    const okM = s[8] === MONTHS[bd.m - 1];
    const okD = dd === bd.d;
    if (!(okY && okM && okD)) issues.push("la data di nascita");
  }

  const toks = normalize(nominativo).replace(/[^A-Z\s]/g, " ").trim().split(/\s+/).filter(Boolean);
  if (toks.length >= 2) {
    const cfNames = s.slice(0, 6);
    const cognomeNome = surnameCode(toks[0]) + nameCode(toks.slice(1).join(""));
    const nomeCognome = surnameCode(toks[toks.length - 1]) + nameCode(toks.slice(0, -1).join(""));
    if (cfNames !== cognomeNome && cfNames !== nomeCognome) issues.push("il nome/cognome");
  }

  const cfComune = s.slice(11, 15);
  if (natoA && natoA.trim() && !cfComune.startsWith("Z")) {
    const expected = belfioreCode(natoA);
    if (expected && expected !== cfComune) issues.push("il comune di nascita");
  }

  if (issues.length) {
    return { level: "warn", message: `Codice Fiscale formalmente valido ma non coerente con ${issues.join(" e ")}.` };
  }
  return { level: "ok", message: "Codice Fiscale valido e coerente." };
}
